import DoctorsTabComponent from './doctors-tab-component.vue';
import CreditsTabComponent from './credits-tab-component.vue';
import MemberProfileComponent from './member-profile-component.vue';

export {
    DoctorsTabComponent,
    CreditsTabComponent,
    MemberProfileComponent,
}